<template>
  <div :class="cartData.favorTip && !isClose ? 'tip-close' : ''">
    <dl :class="cartData.favorTip ? '' : 'no-tip'">
      <dt @click="close" v-if="isClose">
        <i class="el-icon-close" />
      </dt>
      <dd :class="!isClose ? 'dd-close' : ''">
        <div v-if="cartData.favorTip">
          <p class="icon">
            <img src="../../assets/images/didi/coupon-icon.png" />
          </p>
          <div class="title-tip">
            <RichText :text="cartData.favorTip" :isArgb="true" />
          </div>
        </div>
        <div v-else>{{ $t('已购菜品') }}</div>
      </dd>
    </dl>
  </div>
</template>

<script>
import RichText from '@/components/RichText/index.vue';
export default {
  data() {
    return {};
  },
  props: {
    cartData: {
      type: Object,
      default: () => {},
    },
    isClose: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    RichText,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.tip-close {
  position: fixed;
  right: 40px;
  top: 40px;
  // animation: rtl-drawer-in 0.1s 0.1ms;
  // animation: tipclose 0.3s;
  dl {
    border-radius: 8px 8px 0 0;
    // box-shadow: 0px 12px 20px rgba($color: #000, $alpha: 0.04);
  }
}
dl {
  display: flex;
  padding: 10px 12px;
  box-sizing: border-box;
  font-size: 14px;
  align-items: center;
  background: linear-gradient(90deg, #fff2e7 0%, #ffeadf 100%);
  opacity: 0.96;
  border-radius: 8px 8px 0 0;
  dt {
    width: 30px;
    font-size: 20px;
    cursor: pointer;
  }
  dd {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    > div {
      display: flex;
    }
    .icon {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 24px;
        margin-right: 6px;
      }
    }
    .title-tip {
      font-size: 14px;
      line-height: 20px;
      text-indent: 0;
      font-weight: 200;
      display: flex;
      align-items: center;
    }
  }
  .dd-close {
    justify-content: unset;
  }
}
.no-tip {
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  dd {
    text-indent: -10px;
    font-family: 'Aspira Medium';
    font-weight: 500;
  }
}
@media screen and (max-width: 768px) {
  .tip-close {
    right: 0;
    top: 0;
  }
  dl {
    padding: rem(16) rem(24);
    font-size: rem(28);
    border-radius: rem(16) rem(16) 0 0;
    dt {
      width: rem(60);
      font-size: rem(40);
    }
    dd {
      .icon {
        width: rem(60);
        img {
          width: rem(54);
        }
      }
      .title-tip {
        font-size: rem(28);
        line-height: rem(40);
      }
    }
  }
}
</style>
